(() => {
  if (window.onehalfHeaderProgress) return;
  window.onehalfHeaderProgress = true;

  const root = document.documentElement;
  let ticking = false;

  const update = () => {
    const max = root.scrollHeight - window.innerHeight;
    const progress = max > 0 ? Math.min(Math.max(window.scrollY / max, 0), 1) : 0;
    root.style.setProperty('--oh-scroll-progress', progress.toFixed(4));
    ticking = false;
  };

  const request = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  update();
})();
